
<template>
  <div class="index">
    <component :is="'banner-' + $store.state.device"></component>
    <component :is="$store.state.device"></component>
  </div>
</template>

<script>
import m from './device/m.vue'
import pc from './device/pc.vue'
import BannerPc from '@/components/banner-pc.vue'
import BannerM from '@/components/banner-m.vue'

export default {
  name: 'index',

  components: {
    pc,
    m,
    BannerPc,
    BannerM
  }
}
</script>
